export enum BranchOrigin {
    CLOVER = "CLOVER",
    DIVIX = "DIVIX",
}